import {Component, Inject} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { InfoHelper } from 'src/app/core/shared/helpers/info.helper';
import { ImageComponent } from "../../../../../core/shared/components/image/image.component";
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-profile-user-dialog',
    templateUrl: 'profile-user-dialog.html',
    styleUrls: ['profile-user-dialog.scss'],
    standalone: true,
    imports: [
      NgIf,
      MatDialogModule,
      MatDividerModule,
      MatButtonModule,
      MatIconModule,
      ImageComponent
    ]
})
export class ProfileUserDialog {
  
  constructor(
    public dialogRef: MatDialogRef<ProfileUserDialog>,
    public infoHelper: InfoHelper
  ) {

  }

  onClose(): void {
    this.dialogRef.close();
  } 
}